"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.facebookF = void 0;
var facebookF = {
  "viewBox": "0 0 1024 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M959 12v264h-157q-86 0-116 36t-30 108v189h293l-39 296h-254v759h-306v-759h-255v-296h255v-218q0-186 104-288.5t277-102.5q147 0 228 12z"
    }
  }]
};
exports.facebookF = facebookF;